
export const BNB_SOCIAL_LINK = [
  {alt: "twitter", icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/assets/twitter`, href: "https://x.com/breadnbutterxyz"},
  {alt: "discord", icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/assets/discord`, href: "https://discord.gg/breadnbutterbnb"},
  {alt: "medium", icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/assets/medium`, href: "https://medium.com/@breadnbutterbnb"},
  {alt: "telegram", icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/assets/telegram`, href: "https://t.me/BreadnButterBNB"},
]
export enum claimStatusEum {
  CLAIMED = "CLAIMED",
  UN_CLAIMED = "UN_CLAIMED",
  UN_STARTED = "UN_STARTED",
  EXPIRED = "EXPIRED",
};

export enum settleStatusEum {
  UN_SETTLE,
  SETTLEING,
  SETTLED,
};


export const firebaseConfig  = {
  local: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyDGv3qAjqQuCUARcS0QjtoRh_Z2RfsmZ4s",
      authDomain: "opbnb-dev.firebaseapp.com",
      projectId: "opbnb-dev",
      storageBucket: "opbnb-dev.appspot.com",
      messagingSenderId: "1020207509166",
      appId: "1:1020207509166:web:b2c236f8893649887cc73f",
      measurementId: "G-E80MS0032Y",
    }
  },
  dev: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyDGv3qAjqQuCUARcS0QjtoRh_Z2RfsmZ4s",
      authDomain: "opbnb-dev.firebaseapp.com",
      projectId: "opbnb-dev",
      storageBucket: "opbnb-dev.appspot.com",
      messagingSenderId: "1020207509166",
      appId: "1:1020207509166:web:b2c236f8893649887cc73f",
      measurementId: "G-E80MS0032Y",
    },
  },
  beta: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyAp2W6OatOJXjfVuDVtyC9g1vOpxkc55Xg",
      authDomain: "opbnb-beta.firebaseapp.com",
      projectId: "opbnb-beta",
      storageBucket: "opbnb-beta.appspot.com",
      messagingSenderId: "696187340036",
      appId: "1:696187340036:web:9f8ea534f881ebe712bc51",
      measurementId: "G-M1E5R5N7ZS",
    },
  },
  beta1: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyAp2W6OatOJXjfVuDVtyC9g1vOpxkc55Xg",
      authDomain: "opbnb-beta.firebaseapp.com",
      projectId: "opbnb-beta",
      storageBucket: "opbnb-beta.appspot.com",
      messagingSenderId: "696187340036",
      appId: "1:696187340036:web:9f8ea534f881ebe712bc51",
      measurementId: "G-M1E5R5N7ZS",
    },
  },
  pre: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyCtUidbSTtVXyuy3NU6DujTZzNsIFAhZWg",
      authDomain: "opbnb-pre-fd78c.firebaseapp.com",
      projectId: "opbnb-pre-fd78c",
      storageBucket: "opbnb-pre-fd78c.appspot.com",
      messagingSenderId: "637709577545",
      appId: "1:637709577545:web:9392080865d6fd45e3fe98",
      measurementId: "G-1ZF5CPB8WS",
    },
  },
  prod: {
    firebaseConfig: {
      // Your web app's Firebase configuration here
      // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
      apiKey: "AIzaSyBaWtIDn0Gvy5IEZ5quWWpNxQN3HsyvvTQ",
      authDomain: "opbreadnbutter-prod.firebaseapp.com",
      projectId: "opbreadnbutter-prod",
      storageBucket: "opbreadnbutter-prod.appspot.com",
      messagingSenderId: "295783845006",
      appId: "1:295783845006:web:adf90bff6b5c063b110ddf",
      measurementId: "G-49GL5E3HR1",
    },
  },
};